export type VocabularySortMode = 'alphabetical' | 'dateAdded'

const STORAGE_KEY = 'lexio-vocabulary-sort'

export function loadVocabularySort(): VocabularySortMode {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    if (value === 'alphabetical' || value === 'dateAdded') {
      return value
    }
  } catch {
    // ignore
  }
  return 'alphabetical'
}

export function saveVocabularySort(mode: VocabularySortMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    // ignore
  }
}
